export default "__VITE_ASSET__da8a516d__"